const paths = {
  show: `${process.env.NEXT_PUBLIC_API_HOST}/api/vendors/deals/:deal_id/deal_repair`
};

export const getModelNumberFilePath = (dealId: number): string =>
  paths.show.replace(':deal_id', String(dealId));
